var map = {
	"./chicka_chicka_boom_boom.jpg": 1275,
	"./farm_animals.jpg": 1276,
	"./geraldine_the_music_mouse.jpg": 1277,
	"./my_five_senses-aliki.jpg": 1278,
	"./my_five_senses-miller.jpg": 1279,
	"./on_the_farm.jpg": 1280,
	"./rap_a_tap_tap_heres_bojangles.jpg": 1281,
	"./the_little_red_hen-muldrow.jpg": 1282,
	"./the_little_red_hen-pinkney.jpg": 1283,
	"./the_three_billy_goats_gruff-finch.jpg": 1284,
	"./the_three_billy_goats_gruff-galdone.jpg": 1285,
	"./the_year_at_maple_hill_farm.jpg": 1286,
	"./three_little_pigs-kliros.jpg": 1287,
	"./three_little_pigs-marshall.jpg": 1288
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1274;